// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"366":"be0a8bed","624":"caa3b3ea"}[chunkId] + ".css";
};